import React from "react";

const SectionTitle = ({ title }) => {
    return (
        <h3 className="text-xl font-inter font-semibold text-ec-title px-[30px] pt-[20px] pb-[16px] max-[1600px]:pr-0  max-[1600px]:pl-5">
            {title}
        </h3>
    );
};

export default SectionTitle;
